import React, { useEffect, useContext } from "react"; // ✅ Add useEffect here
import { Link, useLocation } from "react-router-dom";
import {
  FaBriefcase,
  FaChalkboardTeacher,
  FaChevronRight,
  FaHome,
} from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { IoMdBriefcase } from "react-icons/io";
import { toast } from 'react-toastify';
import styles from "../Styles/Components/MobileNavOptions.module.css";
import AuthContext from "../store/AuthContext";

const MobileNavOptions = ({ isVisible, mobileNavVisibleHandler }) => {
  const location = useLocation();
  const authCtx = useContext(AuthContext);

  const handleNavClick = (to) => (e) => {
    if (location.pathname === to) {
      e.preventDefault();
      mobileNavVisibleHandler(false);
      setTimeout(() => window.scrollTo(0, 0), 400); // Delay to allow menu close animation
    }
  };

  /* ✅ Prevent background scroll when menu is open */
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden"; // ✅ Lock html too
    } else {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto"; // ✅ Restore html scroll
    }

    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, [isVisible]);
  

  return (
    <div
      className={`${styles.mainContainer} ${ 
        isVisible ? styles.show : styles.hide
      }`}
    >
      <div className={styles.header}>
      <div className={styles.leftHeaderWrapper}>
          <a href="/">
            <img
              src="https://d26wg3m90fktzo.cloudfront.net/uploads/001721807041000002/1761386600402-logo-stylelink-small-pink.png"
              className={styles.logo}
              alt="stylelink logo"
            />
          </a>
        </div>
        <button
          aria-label="Close Menu"
          onClick={() => mobileNavVisibleHandler(false)}
          className={styles.closeButton}
        >
          <GrClose size={24} />
        </button>
      </div>

      <div className={styles.body}>
        <div>
          {/* <div className={styles.headerSectionTitle}>Website</div> */}

          <Link className={`${styles.eachNavOption} ${location.pathname === "/" ? styles.active : ""}`} to="/" onClick={handleNavClick("/")}>
            <div className={styles.navOptionContent}>
              <FaHome />
              <span>Home</span>
            </div>
            <FaChevronRight className={styles.iconRight} />
          </Link>

          <Link className={`${styles.eachNavOption} ${location.pathname === "/salon-jobs-near-me" ? styles.active : ""}`} to="/salon-jobs-near-me" onClick={handleNavClick("/salon-jobs-near-me")}>
            <div className={styles.navOptionContent}>
              <FaBriefcase />
              <span>Jobs</span>
            </div>
            <FaChevronRight className={styles.iconRight} />
          </Link>

          <Link className={`${styles.eachNavOption} ${location.pathname === "/get-my-salon-resume" ? styles.active : ""}`} to="/get-my-salon-resume" onClick={handleNavClick("/get-my-salon-resume")}>
            <div className={styles.navOptionContent}>
              <FaChalkboardTeacher />
              <span>Get Resume</span>
            </div>
            <FaChevronRight className={styles.iconRight} />
          </Link>
        </div>

        <div>
          {/* <div className={styles.headerSectionTitle}>Useful Links</div> */}
          <Link className={`${styles.eachNavOption} ${location.pathname === "/hire-salon-staff" ? styles.active : ""}`} to="/hire-salon-staff" onClick={handleNavClick("/hire-salon-staff")}>
            <div className={styles.navOptionContent}>
              <IoMdBriefcase />
              <span>Hire Salon Staff</span>
            </div>
            <FaChevronRight className={styles.iconRight} />
          </Link>
        </div>
      </div>

      <div className={styles.footer}>
        {authCtx?.isLoggedIn === false && (
          <Link to="/login" className={styles.loginWrapper}>
            Login
          </Link>)}
        {/* {authCtx?.isLoggedIn === false ? (
          <Link to="/login" className={styles.loginWrapper}>
            Login
          </Link>
        ) : (
          <Link
            onClick={() => {
              toast.success("Logged out successfully!");
              authCtx.logout();
              mobileNavVisibleHandler(false);
            }}
            to="/"
            className={styles.loginWrapper}
          >
            Logout
          </Link>
        )} */}
      </div>
    </div>
  );
};

export default MobileNavOptions;
